import React from "react";
import {NavLink} from "react-router-dom";

const Navbar = ({variant = "dark"}) => {
  const isDark = variant === "dark";

  const baseClasses = isDark
    ? "text-white/90 hover:text-white [text-shadow:0_1px_4px_rgba(0,0,0,0.5)]"
    : "text-earth-600 hover:text-pine-700";

  const activeClasses = isDark
    ? "text-white border-b-2 border-moss-400 pb-1"
    : "text-pine-800 border-b-2 border-pine-700 pb-1";

  return (
    <nav className="flex justify-center space-x-8 py-4">
      <NavLink
        to="/"
        className={({isActive}) =>
          `transition-colors duration-200 font-medium ${baseClasses} ${
            isActive ? activeClasses : ""
          }`
        }
      >
        Home
      </NavLink>
      <NavLink
        to="/about"
        className={({isActive}) =>
          `transition-colors duration-200 font-medium ${baseClasses} ${
            isActive ? activeClasses : ""
          }`
        }
      >
        About
      </NavLink>
    </nav>
  );
};

export default Navbar;
